import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

interface ContextMenuItem {
  id: string;
  defaultMessage: string;
  onClick: () => null;
  Icon: SvgIconComponent;
  divided?: boolean;
  color?: string;
}

export const contextMenuActionsList: ContextMenuItem[] = [
  {
    id: 'configurations.company.paymentProviders.provider.contextMenu.viewTransactions',
    defaultMessage: 'View transactions',
    onClick: () => null,
    Icon: VisibilityOutlinedIcon,
  },
  {
    id: 'configurations.company.paymentProviders.provider.contextMenu.disconnect',
    defaultMessage: 'Disconnect Provider',
    onClick: () => null,
    Icon: LinkOffOutlinedIcon,
    divided: true,
    color: 'error',
  },
];
